/** HashRouter-aware in-app path (e.g. `/#/incidents` → `/incidents`). */
export function getAppPathname(): string {
  if (typeof globalThis.location === "undefined") return "";

  const hashRoute = globalThis.location.hash.replace(/^#/, "").split("?")[0];
  if (hashRoute) {
    return hashRoute.startsWith("/") ? hashRoute : `/${hashRoute}`;
  }

  return globalThis.location.pathname || "/";
}
